import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ISensorResourceFieldsFragment = {
  infuseId?: string | null
  templateId?: string | null
  data?: any | null
  linkedEquipment?: {
    id?: any | null
    name: string
    data?: any | null
    color: string
    iconName: string
  } | null
}

export type ISaveSensorsMutationVariables = Types.Exact<{
  sensors: Array<Types.ISensorInput> | Types.ISensorInput
}>

export type ISaveSensorsMutation = {
  saveManySensors?: Array<{
    id?: any | null
    name: string
    infuseId?: string | null
    projectId: any
    type?: Types.LocationType | null
    templateId?: string | null
    data?: any | null
  } | null> | null
}

export const SensorResourceFieldsFragmentDoc = gql`
  fragment SensorResourceFields on Sensor {
    infuseId
    templateId
    data
    linkedEquipment {
      id
      name
      data
      color
      iconName
    }
  }
`
export const SaveSensorsDocument = gql`
  mutation SaveSensors($sensors: [SensorInput!]!) {
    saveManySensors(sensors: $sensors) {
      id
      name
      infuseId
      projectId
      type
      templateId
      data
    }
  }
`
export type ISaveSensorsMutationFn = Apollo.MutationFunction<
  ISaveSensorsMutation,
  ISaveSensorsMutationVariables
>

/**
 * __useSaveSensorsMutation__
 *
 * To run a mutation, you first call `useSaveSensorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSensorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSensorsMutation, { data, loading, error }] = useSaveSensorsMutation({
 *   variables: {
 *      sensors: // value for 'sensors'
 *   },
 * });
 */
export function useSaveSensorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveSensorsMutation,
    ISaveSensorsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveSensorsMutation,
    ISaveSensorsMutationVariables
  >(SaveSensorsDocument, options)
}
export type SaveSensorsMutationHookResult = ReturnType<
  typeof useSaveSensorsMutation
>
export type SaveSensorsMutationResult =
  Apollo.MutationResult<ISaveSensorsMutation>
export type SaveSensorsMutationOptions = Apollo.BaseMutationOptions<
  ISaveSensorsMutation,
  ISaveSensorsMutationVariables
>
